<template>
  <div class="col-md-6 col-12 mb-3 mb-md-0">
    <div class="border-c9c9c9 d-flex flex-column py-4 px-4"
         :class="signature ? 'signed-area' : 'not-signed-area'"
         :style="[signature ? '' : 'height: 400px;']">
      <span class="c-a0a0a0">
        Full Name
      </span>
      <span class="f-bold">
        {{ full_name }}
      </span>
      <div class="d-flex flex-column mt-3">
        <span class="c-a0a0a0">
          Date
        </span>
          <span class="f-bold">
          {{ dateFormat(contract_date, 'date') }}
        </span>
      </div>
      <div v-if="signature" class="d-flex flex-column mt-3 pb-3">
        <span class="c-a0a0a0">
          Signature
        </span>
        <div class="d-flex flex-lg-row flex-column">
          <img :src="signature"
             width="180px" />
          <div>
            <div class="btn ls-btn-tertiary s-12 ml-lg-1 mt-2 mt-lg-0"
                 v-if="isChangeable"
                 @click="$emit('sign')"
                 style="width: 90px">
              Change
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-end h-100 py-4"
           v-else-if="isChangeable">
        <div class="btn ls-btn-secondary px-3"
             @click="$emit('sign')"
             style="width: 300px; font-size: 16px;">
          Click to Sign
        </div>
      </div>
    </div>
    <div class="border-96ba64 d-flex flex-row align-items-center px-4 py-3 ls-bg-f9fff0"
         v-if="signature">
      <span class="mr-4">
        <img src="/assets/img/signed_logo.png"
             width="70px"/>
      </span>
      <div class="d-flex flex-column">
        <span class="c-96ba64 f-bold">
          Signed Digitally
        </span>
        <span class="c-96ba64 f-bold">
          {{ dateFormat(sign_date) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DateMixin from '@/modules/common/mixins/date.mixin';

export default {
  name: 'SignatureBar',
  mixins: [DateMixin],
  props: {
    full_name: {
      required: true,
    },
    signature: {
      required: false,
    },
    sign_date: {
      required: false,
    },
    contract_date: {
      required: true,
    },
    isChangeable: {
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.c-a0a0a0 {
  color: #a0a0a0;
}

.c-96ba64 {
  color: #96ba64;
}

.ls-bg-f9fff0 {
  background: #f9fff0;
}

.border-96ba64 {
  border: 1px solid #96ba64;
}

.border-c9c9c9 {
  border: 1px solid #c9c9c9;
}

.signed-area {
  border-bottom: 0;
  height: 210px;
}

.not-signed-area {
  height: 313px;
}

@media (max-width: 1023px) {
  .signed-area {
    border-bottom: 0;
    height: 310px;
  }

  .not-signed-area {
    height: 413px;
  }
}

</style>
